import $ from 'jquery';

const usga = window.usga;
// fixme
const isProd = (usga.isProd !== undefined) ? $.isFunction(usga.isProd) ? usga.isProd() : !!usga.isProd : true;

export const usgaConfig = {
	cloudName: isProd ? 'usga' : 'usga',
	/*
    gigyaApiKey: isProd ? '3_2XjOryTsvLPQvhvmmwB8TY-OB_6VT05LD5NVNZjYl1TTvIhq_2kEmKcC9MG1LbVw'
        : '3_2XjOryTsvLPQvhvmmwB8TY-OB_6VT05LD5NVNZjYl1TTvIhq_2kEmKcC9MG1LbVw',
    */
	gigyaApiKey: isProd ? '3_2XjOryTsvLPQvhvmmwB8TY-OB_6VT05LD5NVNZjYl1TTvIhq_2kEmKcC9MG1LbVw'
		: '3_5B0rrVdH06F8hPSY0XgLXrpXMRDgP6M5v5lF60lKTkALovXxebE6I0IvdNBV0w2g',
	gigyaBaseServiceUrl: isProd ? '//account.usga.org' : '//staging.account.usga.org',
	teamApproachMemberInfoWebserviceUrl: isProd ? 'https://members.usga.org/data/endpoints/MemberInfo.asmx'
		: 'https://qa-members.usga.org/qa/data/endpoints/MemberInfo.asmx',
	pipCheckOutUrl: isProd ? 'https://members.usga.org/signup_membership/' : 'https://qa-members.usga.org/signup_membership/',
	donationCheckOutUrl: isProd ? 'https://members.usga.org/signup_donation/' : 'https://qa-members.usga.org/qa/signup_donation/donate.aspx',
	clubhouseHomeUrl: isProd ? 'https://www.usga.org/clubhouse/' : '/clubhouse.html',
	defaultJoinFlowUrl: isProd ? '/clubhouse/campaigns/members-join.html' : '/clubhouse/campaigns/members-join.html',
	defaultRenewFlowUrl: isProd ? '/clubhouse/campaigns/members-renew.html' : '/clubhouse/campaigns/members-renew.html',
	defaultReacquisitionUrl: isProd ? '/clubhouse/campaigns/members-renew-offer.html' : '/clubhouse/campaigns/members-renew-offer.html',
	alternateJoinUrl: isProd ? '/clubhouse/campaigns/members-renew-guest.html' : '/clubhouse/campaigns/members-renew-guest.html',
	eventsPhpApiUrl: isProd ? 'http://clubhouse.usga.org/Events/api/' : 'http://events-usgamc.mngd.org/api/'
};
